module.exports = "/_next/static/images/icon-selected-4f3a523a.png";